import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-no-access-page',
  standalone: true,
  template: `
    <div class="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 class="text-2xl font-semibold">No project access</h1>
      <p class="max-w-md text-sm text-gray-600">
        You're signed in as <span class="font-mono">{{ auth.me()?.email }}</span>,
        but you're not a member of any Azure DevOps project team in this organization.
        Ask a project admin to add you to the relevant team.
      </p>
      <button
        type="button"
        class="rounded border px-3 py-1 text-sm hover:bg-gray-50"
        (click)="auth.signOut()">
        Sign out
      </button>
    </div>
  `,
})
export class NoAccessPageComponent {
  readonly auth = inject(AuthService);
}
